class HeroCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-carousel__slide'));
    this.current = 0;

    // Apply the first slide's arrow colour immediately
    this.applyArrowColor(0);

    if (this.slides.length <= 1) return;

    this.querySelector('.hero-carousel__arrow--prev')
      ?.addEventListener('click', () => this.advance(-1));

    this.querySelector('.hero-carousel__arrow--next')
      ?.addEventListener('click', () => this.advance(1));

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.advance(-1);
      if (e.key === 'ArrowRight') this.advance(1);
    });

    this.initSwipe();
    this.initAutoplay();
  }

  advance(dir) {
    const next = (this.current + dir + this.slides.length) % this.slides.length;
    this.goTo(next);
  }

  goTo(index) {
    const prev = this.current;

    this.slides[prev].classList.remove('is-active');
    this.slides[prev].setAttribute('aria-hidden', 'true');
    this.slides[prev].querySelector('.hero-carousel__slide-link')
      ?.setAttribute('tabindex', '-1');

    this.current = index;

    this.slides[index].classList.add('is-active');
    this.slides[index].setAttribute('aria-hidden', 'false');
    this.slides[index].querySelector('.hero-carousel__slide-link')
      ?.setAttribute('tabindex', '0');

    this.applyArrowColor(index);
  }

  applyArrowColor(index) {
    const color = this.slides[index]?.dataset.arrowColor;
    if (color) {
      this.style.setProperty('--arrow-color', color);
    }
  }

  initAutoplay() {
    const enabled = this.dataset.autoplay === 'true';
    if (!enabled) return;

    const speed = parseInt(this.dataset.autoplaySpeed, 10) || 6000;

    const start = () => {
      clearInterval(this._autoplayTimer);
      this._autoplayTimer = setInterval(() => this.advance(1), speed);
    };

    const stop = () => {
      clearInterval(this._autoplayTimer);
    };

    start();

    this.addEventListener('mouseenter', stop);
    this.addEventListener('mouseleave', start);

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stop() : start();
    });
  }

  initSwipe() {
    let startX = 0;
    let startY = 0;
    let dragging = false;
    this._isSwiping = false;

    this.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      startY = e.clientY;
      dragging = true;
      this._isSwiping = false;
    });

    this.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      if (Math.abs(e.clientX - startX) > 8) {
        this._isSwiping = true;
      }
    });

    this.addEventListener('pointerup', (e) => {
      if (!dragging) return;
      dragging = false;

      const diffX = startX - e.clientX;
      const diffY = startY - e.clientY;

      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        this.advance(diffX > 0 ? 1 : -1);
      }

      if (this._isSwiping) {
        e.preventDefault();
      }
    });

    this.addEventListener('click', (e) => {
      if (this._isSwiping) {
        e.preventDefault();
        e.stopPropagation();
        this._isSwiping = false;
      }
    }, true);
  }
}

customElements.define('hero-carousel', HeroCarousel);